export default function Home() {

  

  return (
    <div className="home">
      <h1>Dont Break the Cycle</h1>
      <p>
        Cycling can be fun and adventurous, but if your not careful it can also be dangerous.
        Whether it's a problem with your bike or hazards on the road, there is a lot that can go wrong.
        Luckily there are many tips for both bicycle maintenance and safety that can help you out.
        Have any tips for us? Feel free to share.

    </p>
    </div>
  
  )
}
